
const other = {
  "Other FAQs": [
    {
      question: "How do I get started and what are the steps to invest?",
      answer: "You can login to " +
      `<a href=${process.env.REACT_APP_BASE_URL_ICM} target="_blank" style='color:#283A97'><u>www.biddeasy.com</u></a> using your Mobile Number. You can complete the KYC on the platform. Post that, you would be eligible to invest.` +
      "<br /><br />" +
      "Step 1: Once the issue is live, you can select the amount you would wish to invest.<br />" +
      "Step 2: Review and sign the documents.<br />" +
      "Step 3: Complete your payment. Your investments will reflect in your DEMAT account in 3 working days."
    },
    {
      question: "Is the investment process digital?",
      answer: "Yes, the investment process is completely digital."
    },
    {
      question: "Who can Invest on Bidd?",
      answer: "Anyone who is above 18 years of age and has KYC verified can invest through the Bidd platform."
    },
    {
      question: "What documents do I need to invest on Bidd?",
      answer: "Minimum KYC documents like PAN, Address proof , bank account details and DEMAT details are required for onboarding."
    },
    {
      question: "Are there any charges/ brokerage to invest in the Bond?",
      answer: "No, there are no charges/ brokerage to invest in a Bond."
    },
    {
      question: "What is the Tax on Interest payments for a Bond?",
      answer: "Interest will be taxed at the slab rate applicable to you. TDS at 10% would be deducted as per the Income Tax Act. One can submit Form 15G/15H if they don’t want TDS to be deducted."
    },
    {
      question: "Where can I view my investments on Bidd?",
      answer: "<a href='/platform/#/' style='color:#283A97'><u>Click here to view your investments.</u></a>"
    },
    {
      question: "Is Bidd regulated?",
      answer: "Yes, Bidd is compliant with applicable regulatory norms."
    },
    {
      question: "Where can I track my investments on Bidd?",
      answer: "Once the transaction is processed, you can view your investment in your DEMAT account. The investment may take 3-5 working days to reflect in your DEMAT. In case, you can't find your investment details in DEMAT, please reach out to us and our support team will assist you further."
    },
    {
      question: "In case of any query, how can I reach out to Bidd support?",
      answer: "If you have any query, please feel free to email us on <a href='mailto:connect@biddeasy.com' style='color:#283A97'><u>connect@biddeasy.com</u></a> or contact us on +91 8591871028 or +91 8928250817."
    },


  ]
}

export default other;